export const roles = {
  SUPERADMIN: 'SUPERADMIN',
  ADMIN: 'ADMIN',
  AUDITOR_DOC: 'AUDITOR_DOC',
  PRESTADOR: 'prestador',
} as const;

export const pathsByRole: Record<string, string> = {
  SUPERADMIN: '/admin',
  ADMIN: '/admin',
  AUDITOR_DOC: '/auditor',

  PRESTADOR: '/prestador',
  PACIENTE: '/paciente',
};

export type Rol = keyof typeof roles;
